var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"dense":"","color":_vm.color,"disabled":_vm.disabled,"hide-details":"","item-color":_vm.itemColor,"items":_vm.items,"label":_vm.label,"outlined":"","value":_vm.value},on:{"change":_vm.emitChangeEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }